import { Button, Chip, CloseIcon, Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePreviousSchoolYear } from '../../../hooks/useSelectedSchoolYear';
import { FactorInheritForm } from '../forms/FactorInheritForm';
import styles from './FactorInheritModal.module.scss';

type FactorInheritModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const FactorInheritModal = ({ isOpen, onClose }: FactorInheritModalProps) => {
  const { t } = useTranslation();
  const previousSchoolYear = usePreviousSchoolYear();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      className={styles['factor-inherit-modal']}
      customHeader={
        <div className={styles.header}>
          <div className={styles.title}>{t('common.inheritFromPreviousYear')}</div>
          {previousSchoolYear && <Chip className={styles.chip} value={previousSchoolYear.shortName} />}
          <Button className={styles.button} hierarchy='tertiary' icon={<CloseIcon />} onClick={onClose} />
        </div>
      }
      loading={loading}
      width='l'
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <FactorInheritForm onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
